export default __webpack_public_path__ + "static/media/tmb.alt.af18581f.png";